import React, {Component} from 'react';
import { ImageView } from 'c-up-ui';
import lang from '../lang/index';
import global from '../base/global';
import getTime from '../base/time';


class CommentList extends Component{
	static defualtProps = {
		comments: []
	}

	constructor(props){
		super(props);
	}

	goProfile=(uid)=>{
		 global.goUpliveProfile(uid);
	}

	render() {
		return (
			<div className="comment-wrapper">
				<h2>{lang.template('评论')}</h2>
				<ul>
					{
						this.props.comments.slice(0, 3).map((item, index)=>{
							let {userInfo, content, createTime, replyUserInfo} =  item;

							return (
								<li key={index} className="comment" onClick={this.goProfile.bind(this, userInfo.uid)}>
									<div className="avatar">
										<ImageView src={userInfo.avatar} size={32} circle/>
									</div>
									<div className="content">
										<div className="username">{userInfo.userName}</div>
										{ 
											replyUserInfo.uid ? 
											<div className="text"><i>{lang.template('回复')}</i><label>{replyUserInfo.userName}:</label><span>{content.text}</span></div> 
											: 
											<div className="text">{content.text}</div> 
										}
									</div>
									<div className="time">{getTime(createTime * 1000)}</div>
								</li>
							)
						})
					}
					<li key="3"><span className="more-tip" onClick={()=> $.channel.emit('download')} >{lang.template('查看更多评论')}</span></li>
				</ul>
			</div>
		);
	}
}


export default CommentList;


// WEBPACK FOOTER //
// ./js/feedshare/comment.js